module.exports = __webpack_public_path__ + "img/google-search.b0ff8988.svg";